import React, { useEffect, useState } from 'react';
import {
  Button,
  Grid,
  Typography,
  makeStyles
} from '@material-ui/core';

import Dialog from '../ui/Dialog';
import LoadingOverlay from '../LoadingOverlay/LoadingOverlay.component';
import { updateVoucherRedeemDate } from '../../services/transaction.service';
import DatePicker from '../DatePicker/DatePicker.component';

const UpdateVoucherRedemption = ({ data }) => {
  const { code_id, program_id } = data;
  const [redeemedDate, setRedeemedDate] = useState(new Date());

  const [state, setState] = useState({
    openModal: true,
    openConfirmation: false,
    modalTitle: 'Update Voucher Redemption',
    errorMessage: null,
    successMessage: 'Successfully updated voucher redemption!',
    isLoading: false,
  });

  const onUpdateVoucherRedemption = async () => {
    setState(prev => ({ ...prev, isLoading: true }));
    try {
      await updateVoucherRedeemDate({
        connect_program_id: program_id,
        voucher_code: code_id,
        payload: {
          redeemdate: redeemedDate
        }
      });
    } catch (error) {
      setState(prev => ({
        ...prev,
        errorMessage: error.message
      }));
    } finally {
      setState(prev => ({ ...prev, isLoading: false, openConfirmation: true, openModal: false }));
    }
  }


  const handleClose = () => {
    const { openConfirmation } = state;
    setState(prev => ({
      ...prev,
      openModal: false,
      openConfirmation: false,
      errorMessage: null
    }));

    if (openConfirmation) {
      window.location.reload();
    }
  };

  const {
    openModal,
    openConfirmation,
    modalTitle,
    successMessage,
    isLoading,
  } = state;

  if (isLoading) return <LoadingOverlay />;

  const formContent = (
    <>
      <Grid
        item
        container
        xs={12}
        spacing={2}
      >
        <Grid item xs={12}>
            <DatePicker
                label='Redemption Date*'
                value={redeemedDate}
                  onChange={(date) => setRedeemedDate(date)} 
              />
        </Grid>
      </Grid>
    </>
  );

  const formButtons = (
    <>
      <Button onClick={handleClose} variant="contained">
        {openConfirmation ? 'OK' : 'Close'}
      </Button>
      {!openConfirmation && (
        <Button
          onClick={onUpdateVoucherRedemption}
          variant="contained"
          color="primary"
        >
          Update
        </Button>
      )}
    </>
  );

  return (
    <>
      <Dialog
        key="update-voucher-redemption"
        open={openModal}
        title={modalTitle}
        content={formContent}
        children={formButtons}
        onSubmit={onUpdateVoucherRedemption}
        onClose={handleClose}
      />
      <Dialog
        onSubmit={() => handleClose()}
        key="confirmation"
        open={openConfirmation}
        title="Confirmation"
        content={successMessage}
        children={formButtons}
        onClose={handleClose}
      />
    </>
  );
};

export default  UpdateVoucherRedemption;